export const SEASONAL_THEMES = {
  spring: {
    light: {
      bg: "#FDF6F9", card: "#FFFFFF", primary: "#E8679A", primaryLight: "#F48FB1", primaryPale: "#FCE4EC",
      accent: "#66BB6A", accentLight: "#81C784", accentPale: "#E8F5E9", navy: "#4A2040", navyLight: "#8E6C88",
      text: "#2E1A24", textMuted: "#8E7A84", border: "#F0DDE5", borderLight: "#F8EFF3",
      danger: "#E74C3C", dangerPale: "#FDECEB", success: "#66BB6A", successPale: "#E8F5E9",
      warning: "#FFB74D", warningPale: "#FFF3E0", purple: "#AB47BC", purplePale: "#F3E5F5",
      sidebar: "#4A2040", sidebarHover: "rgba(255,255,255,0.15)", sidebarText: "rgba(255,255,255,0.55)", sidebarActive: "#fff",
      inputBg: "#FDF6F9", sidebarGradient: "#6A3058",
    },
    dark: {
      bg: "#1A1218", card: "#261C22", primary: "#F48FB1", primaryLight: "#F8BBD0", primaryPale: "#3D1A2A",
      accent: "#81C784", accentLight: "#A5D6A7", accentPale: "#1A3A1E", navy: "#F8E8F0", navyLight: "#CE93D8",
      text: "#F8E8F0", textMuted: "#C4ACB8", border: "#3D2A34", borderLight: "#2E1C26",
      danger: "#EF5350", dangerPale: "#3B1C1C", success: "#81C784", successPale: "#1A3A1E",
      warning: "#FFB74D", warningPale: "#3D2E14", purple: "#CE93D8", purplePale: "#2D1F33",
      sidebar: "#120A10", sidebarHover: "rgba(255,255,255,0.1)", sidebarText: "rgba(255,255,255,0.45)", sidebarActive: "#fff",
      inputBg: "#1A1218", sidebarGradient: "#2A1424",
    },
    emoji: "🌸", label: "Spring", loginGradient: "linear-gradient(135deg, #FDF6F9 0%, #FCE4EC 50%, #E8F5E9 100%)",
    loginEmojis: ["🌸", "🌷", "🦋", "🐣"], dashEmojis: ["🌸", "🌿"],
  },
  summer: {
    light: {
      bg: "#FFF9F0", card: "#FFFFFF", primary: "#E8852E", primaryLight: "#F5A623", primaryPale: "#FFF0DB",
      accent: "#4CAF7D", accentLight: "#6FCF97", accentPale: "#E3F5EC", navy: "#3D3226", navyLight: "#795548",
      text: "#2C2416", textMuted: "#8B7E6A", border: "#EDE3D3", borderLight: "#F5EFE4",
      danger: "#E74C3C", dangerPale: "#FDECEB", success: "#4CAF7D", successPale: "#E3F5EC",
      warning: "#E8852E", warningPale: "#FFF0DB", purple: "#9B59B6", purplePale: "#F3E8F9",
      sidebar: "#3D3226", sidebarHover: "rgba(255,255,255,0.15)", sidebarText: "rgba(255,255,255,0.55)", sidebarActive: "#fff",
      inputBg: "#FFF9F0", sidebarGradient: "#5D4037",
    },
    dark: {
      bg: "#1A1410", card: "#251E17", primary: "#F5A623", primaryLight: "#FFD080", primaryPale: "#3D2E14",
      accent: "#6FCF97", accentLight: "#A5E8C4", accentPale: "#1A3A2A", navy: "#F5E6D3", navyLight: "#A1887F",
      text: "#F5E6D3", textMuted: "#BEAA96", border: "#3D3226", borderLight: "#2E2519",
      danger: "#E74C3C", dangerPale: "#3B1C1C", success: "#6FCF97", successPale: "#1A3A2A",
      warning: "#F5A623", warningPale: "#3D2E14", purple: "#CE93D8", purplePale: "#2D1F33",
      sidebar: "#120E0A", sidebarHover: "rgba(255,255,255,0.1)", sidebarText: "rgba(255,255,255,0.45)", sidebarActive: "#fff",
      inputBg: "#1A1410", sidebarGradient: "#2A2015",
    },
    emoji: "☀️", label: "Summer", loginGradient: "linear-gradient(135deg, #FFF9F0 0%, #FFE8CC 50%, #E3F5EC 100%)",
    loginEmojis: ["🎨", "📚", "✏️", "🎒"], dashEmojis: ["🎒", "📚"],
  },
  autumn: {
    light: {
      bg: "#FBF5EE", card: "#FFFFFF", primary: "#BF5B21", primaryLight: "#D4762C", primaryPale: "#FAEBD7",
      accent: "#8B6914", accentLight: "#B8941E", accentPale: "#FFF8E1", navy: "#3E2723", navyLight: "#6D4C41",
      text: "#2C1B0E", textMuted: "#8D7B6A", border: "#E8DDD0", borderLight: "#F2ECE4",
      danger: "#C62828", dangerPale: "#FFEBEE", success: "#558B2F", successPale: "#F1F8E9",
      warning: "#E65100", warningPale: "#FFF3E0", purple: "#6A1B9A", purplePale: "#F3E5F5",
      sidebar: "#3E2723", sidebarHover: "rgba(255,255,255,0.15)", sidebarText: "rgba(255,255,255,0.55)", sidebarActive: "#fff",
      inputBg: "#FBF5EE", sidebarGradient: "#5D4037",
    },
    dark: {
      bg: "#1A1308", card: "#261E12", primary: "#D4762C", primaryLight: "#E8A54A", primaryPale: "#3D2810",
      accent: "#B8941E", accentLight: "#D4B52C", accentPale: "#3D3410", navy: "#F0E0CC", navyLight: "#A1887F",
      text: "#F0E0CC", textMuted: "#BEAA88", border: "#3D3020", borderLight: "#2E2418",
      danger: "#EF5350", dangerPale: "#3B1C1C", success: "#8BC34A", successPale: "#1A3A12",
      warning: "#FF9800", warningPale: "#3D2E14", purple: "#BA68C8", purplePale: "#2D1F33",
      sidebar: "#120E06", sidebarHover: "rgba(255,255,255,0.1)", sidebarText: "rgba(255,255,255,0.45)", sidebarActive: "#fff",
      inputBg: "#1A1308", sidebarGradient: "#2A1E10",
    },
    emoji: "🍂", label: "Autumn", loginGradient: "linear-gradient(135deg, #FBF5EE 0%, #FAEBD7 50%, #FFF8E1 100%)",
    loginEmojis: ["🍂", "🍁", "🎃", "🌾"], dashEmojis: ["🍂", "🍁"],
  },
  winter: {
    light: {
      bg: "#F4F7FB", card: "#FFFFFF", primary: "#3B82C4", primaryLight: "#5BA3E0", primaryPale: "#DBEAFE",
      accent: "#7C8DA6", accentLight: "#94A3B8", accentPale: "#E8EEF4", navy: "#1E293B", navyLight: "#475569",
      text: "#1A2030", textMuted: "#6B7B90", border: "#D8E2EE", borderLight: "#ECF0F5",
      danger: "#DC2626", dangerPale: "#FEE2E2", success: "#2E9E6B", successPale: "#D1FAE5",
      warning: "#D97706", warningPale: "#FEF3C7", purple: "#7C3AED", purplePale: "#EDE9FE",
      sidebar: "#1E293B", sidebarHover: "rgba(255,255,255,0.15)", sidebarText: "rgba(255,255,255,0.55)", sidebarActive: "#fff",
      inputBg: "#F4F7FB", sidebarGradient: "#334155",
    },
    dark: {
      bg: "#0C1220", card: "#16202E", primary: "#5BA3E0", primaryLight: "#93C5FD", primaryPale: "#1A2A40",
      accent: "#94A3B8", accentLight: "#CBD5E1", accentPale: "#1E2A38", navy: "#E2E8F0", navyLight: "#94A3B8",
      text: "#E2E8F0", textMuted: "#9DAABB", border: "#243040", borderLight: "#1A2535",
      danger: "#EF4444", dangerPale: "#3B1C1C", success: "#4ADE80", successPale: "#1A3A2A",
      warning: "#F59E0B", warningPale: "#3D2E14", purple: "#A78BFA", purplePale: "#2D2250",
      sidebar: "#080E18", sidebarHover: "rgba(255,255,255,0.1)", sidebarText: "rgba(255,255,255,0.45)", sidebarActive: "#fff",
      inputBg: "#0C1220", sidebarGradient: "#121C2A",
    },
    emoji: "❄️", label: "Winter", loginGradient: "linear-gradient(135deg, #F4F7FB 0%, #DBEAFE 50%, #E8EEF4 100%)",
    loginEmojis: ["❄️", "⛄", "🧤", "🎄"], dashEmojis: ["❄️", "⛄"],
  },
};
export let COLORS = { ...SEASONAL_THEMES.summer.light };

export const setColors = (newColors) => {
  Object.keys(COLORS).forEach(k => delete COLORS[k]);
  Object.assign(COLORS, newColors);
};
